import { GET_ALL_SUBS_PACKAGE, GET_ALL_SUBS_PACKAGE_FAILED, GET_ALL_SUBS_PACKAGE_SUCCESS } from "../../constants/subsPackageConstants"


const initialState = {
    isLoading: false,
    error: null
}

const SubsPackageReducer = (state = initialState, action) => {
    switch(action.type) {
        case GET_ALL_SUBS_PACKAGE:
            return {
                ...state,
                isLoading: true,
            }
         case GET_ALL_SUBS_PACKAGE_SUCCESS:
            return {
                ...action.payload,
                 isLoading: false,
                 error: null
            }
        case GET_ALL_SUBS_PACKAGE_FAILED:
            return {
                 isLoading: false,
                 error: action.payload
            }
        default:
            return state;
    }
}

export default SubsPackageReducer;